// extracted by mini-css-extract-plugin
export default {"row":"Filters_row__QJV5e","tabs":"Filters_tabs__cdj09","tab":"Filters_tab__PaHj2","active":"Filters_active__fUBNp"};